module.exports = __webpack_public_path__ + "img/payCourseMoney.19511f09.png";